import { sortBy } from '../arrays/sort-by';
import { SortOrder } from '../search/sort-order/sort-order.enum';

function sortAggregationValues(name, values) {
  const orderMap = { editionYear: SortOrder.DESC, default: SortOrder.ASC };
  const order = orderMap[name] || orderMap.default;

  return sortBy(values, 'value', order);
}

export function presentAggregations(aggregations) {
  return aggregations.map((aggregation) => ({
    ...aggregation,
    values: sortAggregationValues(aggregation.name, aggregation.values),
  }));
}
